import React, { useEffect, useState } from "react";
import CountryFlag from "../../Components/CouontryFlag/CountryFlag";
import {
  toastError,
  toastInfo,
  toastSuccess,
} from "../../Components/Toasts/Toast";
import Swal from "sweetalert2";
import { getProductColor, getProductTag } from "../../Services/ProductService";
import { getStoreOnlineAll } from "../../Services/StoreOnlineService";

import { isValidUrl, previewFile } from "../../Utils/Utils";
import ProductHighlight from "./ProductHighlight";
import ModalImageHighlight from "../../Components/Product/Modal/ModalImageHighlight";
import ProductDetailInformation from "./ProductDetailInformation";
import ProductUspHighlight from "./ProductUspHighlight";
import ProductEcommerce from "./ProductEcommerce";
import { useSelector } from "react-redux";
import { set } from "react-hook-form";

const { $ } = window;
const modalId4 = "#product-create-modal-image";
const modalId5 = "#product-create-modal-highlight-ups-";
const wrapStyle2 = {
  width: "358.67px",
  height: "133.33px",
  borderRadius: 4,
  marginRight: 16,
  marginBottom: 16,
  position: "relative",
  border: "solid 1px #ccc",
  borderRadius: 6,
};
const wrapStyle = {
  width: 130,
  height: 100,
  borderRadius: 4,
  marginRight: 16,
  marginBottom: 16,
  position: "relative",
  border: "solid 1px #ccc",
  borderRadius: 6,
};

const ProductDetailPage = ({
  countryChange,
  state,
  setState,
  approval_status,
  next_step_nik_detail,
  setHighlightChange,
  setEcomChange,
  setUspChange,
  onSaveDraft,
  is_draft_saved,
  setDetailChange,
  setIsDetailSaved,
}) => {
  if (!state.manualBooksDelete) state.manualBooksDelete = [];
  let { userInfo } = useSelector((state) => state.auth);
  const [detailState, setDetailState] = useState({
    productColors: [],
    productTags: [],
  });

  const [ecomState, setEcomState] = useState({ storeLoc: [] });

  const onSelectLang = (e) => {
    const index = languages.findIndex(
      (lang) => lang.language_code == e.target.value
    );
    const lang = languages[index];
    setState({
      ...state,
      selectedLang: {
        language_code: lang.language_code,
        language_name: lang.language_name,
        title: "",
        header_description: "",
        description: "",
        feature: "",
        including: "",
        tagline: "",
        price: "",
        id_color: "",
        id_tag: "",
        manual_book: null,
        is_preorder: 0,
        is_active: true,
        seo_title: "",
        seo_description: "",
        url_ar: "",
      },
    });
  };
  const handleTabClick = (tab) => {
    if (productDetails.length > 0) {
      setState({ ...state, activeTab: tab });
    }
  };

  const handleOpen = () => {
    setState({ ...state, show: !state.show });
  };

  const onAddLang = () => {
    if (productDetails.length < 2) {
      if (selectedLang.language_code != "") {
        const _productDetails = [...productDetails, selectedLang];
        const _productHighlights = [...productHighlights];
        const _productHighlight = [productHighlight];
        let _productUps = [...productUps];
        // const _filesDescsUpss = [];
        // let _filesDescsUps = [...filesDescsUps];
        // const _filesUps = [...filesUps];
        const _selectedLang = selectedLang;
        const _productEcom = [...productEcom];

        // const langIndex = _productHighlights.findIndex(e => e.language_code == _selectedLang.language_code);
        // const idxTag = _productUps[0].tags.findIndex(e => e.language_code == _selectedLang.language_code);
        // const langIndexUps = _productDetails.findIndex(e => e.language_code == _selectedLang.language_code); // ini ketemu
        if (productDetails.length > 0) {
          _productHighlights
            .filter((high) => high.language_code == productDetail.language_code)
            .map((highlight) => {
              _productHighlights.push({
                id: null,
                language_code: selectedLang.language_code,
                language_name: selectedLang.language_name,
                line_num: highlight.line_num,
                title: "",
                description: "",
              });
            });
        }
        // else {
        //   _productHighlights.push({
        //     id: null,
        //     language_code: selectedLang.language_code,
        //     language_name: selectedLang.language_name,
        //     line_num: 0,
        //     title: "",
        //     description: "",
        //   })
        // }
        if (productDetails.length > 0) {
          _productUps.map((item, index) =>
            item.tags.push({
              line_num: index,
              title: "",
              description: "",
              language_code: _selectedLang.language_code,
            })
          );
        }
        setState({
          ...state,
          productDetails: _productDetails,
          productDetail: _selectedLang,
          selectedLang: _selectedLang,
          productHighlights: _productHighlights,
          productHighlight: _productHighlight,
          _filesUps: filesUps,
          productUps: _productUps,
          productEcom: _productEcom,
        });
      } else {
        toastError("Please select language!");
        return;
      }
    } else {
      toastError("Maks 2 languages!");
      return;
    }
  };

  const onRemoveLang = (language_code) => {
    Swal.fire({
      icon: "question",
      title: "Are you sure?",
      text: "Deleted data can not be restored!",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        const _productDetails = [...productDetails];
        const _productHighlights = [...productHighlights];
        const _productUps = [...productUps];
        const _productEcom = [...productEcom];

        const prodIndex = _productDetails.findIndex(
          (e) => e.language_code == language_code
        );

        let itemCode = null;
        if (_productDetails[prodIndex].item_code != "") {
          itemCode = _productDetails[prodIndex].item_code;
        }

        _productDetails.splice(prodIndex, 1);
        // productHighlights.splice(prodIndex, 1);

        if (prodIndex != -1) {
          if (itemCode) {
            deletedDetail.push({
              itemCode,
              countryCode: countryChange,
              languageCode: language_code,
            });

            let highTemp = 0;
            for (let high in productHighlights) {
              if (productHighlights[high].language_code == language_code) {
                deletedHighlight.push({
                  itemCode,
                  countryCode: countryChange,
                  language_code: language_code,
                  line_num: productHighlights[high].line_num,
                  id: productHighlights[high].id,
                });
                _productHighlights.splice(high - highTemp, 1);
                highTemp++;
              }
            }

            let imageTemp = 0;
            for (let image in productUps) {
              if (productUps[image]) {
                for (let tag in productUps[image].tags) {
                  if (
                    productUps[image].tags[tag].language_code == language_code
                  ) {
                    deletedUpsTag.push({
                      item_code: itemCode,
                      country_code: countryChange,
                      language_code: language_code,
                    });

                    _productUps[image - imageTemp].tags.splice(tag, 1);
                    imageTemp++;
                  }
                }
              }
            }

            let image2Temp = 0;
            if (_productDetails.length == 0) {
              for (let image in productUps) {
                deletedUps.push({
                  id: productUps[image].id,
                });

                _productUps.splice(image - image2Temp, 1);
                image2Temp++;
              }
            }
          }

          // if (_productDetails.length == 0) {
          //   const _productDetails = [];
          //   _productUps = [{
          //     "id": null,
          //     "name": "",
          //     "media_code": "",
          //     "media_type": [],
          //     "media_desc": "",
          //     "content_type": [],
          //     "file_path": "",
          //     "tags": []
          //   }];
          //   // _productUps.map((item, index) =>
          //   //   item.tags.push({
          //   //     "line_num": index,
          //   //     "title": "",
          //   //     "description": "",
          //   //     "language_code": ""
          //   //   })
          //   // )
          // }

          setState({
            ...state,
            productDetail:
              _productDetails.length > 0
                ? _productDetails[0]
                : {
                  language_code: "",
                  language_name: "",
                  title: "",
                  header_description: "",
                  description: "",
                  feature: "",
                  including: "",
                  tagline: "",
                  price: "",
                  manual_book: "",
                  is_preorder: 0,
                  is_rental: 0,
                  is_active: true,
                  seo_title: "",
                  seo_description: "",
                  url_ar: "",
                },
            productDetails: _productDetails,
            productHighlights: _productHighlights,
            productUps: _productUps,
            productEcom: _productEcom,
            deletedDetail,
            deletedHighlight,
            deletedUps,
            deletedUpsTag,
            deletedEcom,
          });
        }
        // else {
        //   if (itemCode) {
        //     deletedDetail.push({
        //       itemCode,
        //       countryCode: countryChange,
        //       languageCode: language_code
        //     });

        //     // deletedHighlight.push({
        //     //   itemCode,
        //     //   countryCode: countryChange,
        //     //   language_code: productDetail.language_code
        //     // })
        //     // deletedUpsTag.push({
        //     //   item_code: itemCode,
        //     //   country_code: countryChange,
        //     //   language_code: productDetail.language_code
        //     // })

        //     for (let high in _productHighlights) {
        //       if (_productHighlights[high].language_code == language_code) {
        //         deletedHighlight.push({
        //           itemCode,
        //           countryCode: countryChange,
        //           language_code: productDetail.language_code
        //         });

        //         _productHighlights.splice(high, 1);
        //       }
        //     }

        //     for (let image in _productUps) {
        //       for (let tag in _productUps[image].tags) {
        //         if (_productUps[image].tags[tag].language_code == language_code) {
        //           deletedUpsTag.push({
        //             item_code: itemCode,
        //             country_code: countryChange,
        //             language_code: productDetail.language_code
        //           });

        //           _productUps[image].tags.splice(tag, 1);
        //         }
        //       }
        //     }
        //   }
        //   setState({ ...state, productDetails: _productDetails, productHighlights: _productHighlights, productUps: _productUps, filesDescsUpss, deletedDetail, deletedHighlight, deletedUps, deletedUpsTag });
        // }
        toastSuccess("Language has been deleted");
      }
    });
  };

  const onFileChange = (e) => {
    const index = manualBooks.findIndex(
      (d) => d[0].name == e.target.files[0].name
    );

    if (index > -1) {
      toastError("Image name already exists");
      return;
    }

    let isValid = true;
    /*for (let key in productDetail) {
      // console.log(key, "Isi: " + productDetail[key]);
      if (
        productDetail[key] == "" &&
        key != "is_active" &&
        key != "is_preorder" &&
        key != "is_rental" &&
        key != "manual_book" &&
        key != "is_me_by_modena" &&
        key != "seo_title" &&
        key != "seo_description" &&
        key != "sku_me_by_modena" &&
        key != "price" &&
        key != "url_ar"
      ) {
        isValid = false;
      }
    }
    console.log(isValid);
    if (!isValid) {
      toastError("Please complete the form first!");
      return;
    }*/

    productDetail.manual_book = e.target.files[0].name;
    manualBooks.push(e.target.files);
    setState({ ...state, productDetail, manualBooks });
    setTimeout(() => {
      onDetailSave();
    }, 250);
  };

  const onLanguageClick = (item) => {
    manualBooks.map((item) => {
      const index = productDetails.findIndex(
        (e) => e.manual_book == item[0].name
      );
      // console.log(index);
      if (index > -1) {
        return item;
      }
    });
    const _productHighlights = [...productHighlights];
    const _productUps = [...productUps];
    //const _filesDescsUpss = [...filesDescsUpss];
    const _filesUps = [...filesUps];
    // const _selectedLang = selectedLang;

    // productDetail.language_code = item.language_code
    // productDetail.language_name = item.language_name

    const index = productDetails.findIndex(
      (e) => e.language_code == item.language_code
    );
    const langIndex = _productHighlights.findIndex(
      (e) => e.language_code == item.language_code
    );
    const _productHighlight =
      _productHighlights.length > 0
        ? _productHighlights[langIndex]
        : [
          {
            language_code: item.language_code,
            language_name: item.language_name,
            title: "",
            description: "",
          },
        ];

    const _productDetail = JSON.parse(JSON.stringify(productDetails[index]));
    setState({
      ...state,
      productDetail: _productDetail,
      filesUps: _filesUps,
      productHighlights: _productHighlights,
      productHighlight: _productHighlight,
      productUps: _productUps,
    });
  };

  const onRemoveFile = (filename) => {
    const index = manualBooks.findIndex(
      (d) => d[0].name == productDetail.manual_book
    );
    manualBooks.splice(index, 1);
    productDetail.manual_book = null;
    manualBooksDelete.push(filename);
    setState({ ...state, productDetail, manualBooks, manualBooksDelete });
    setTimeout(() => {
      onDetailSave();
    }, 250);
  };

  const onDetailChangeText = (e) => {
    const { name, value } = e.target;

    // Check for invalid input (letters) only for "sticker_price"
    if (name === "sticker_price" && /[a-zA-Z]/.test(value)) {
      // Set value to 0, but don't do it if the user is just deleting
      if (value.trim() === "") {
        e.target.value = 0; // Allow empty input to be reset to 0 if nothing is typed
      }
      return; // Do not process further if input is invalid
    }
    const _productDetail = { ...productDetail };
    if (e.target.name == "price") {
      productDetail[e.target.name] = e.target.value == "" ? 0 : e.target.value;
    }
    _productDetail[e.target.name] = e.target.value;

    // setDetailChange(true);
    setState({ ...state, productDetail: _productDetail });
  };

  const onEcoChangeText = (e, index) => {
    const _productEco = { ...productEcom };
    if (e.target.name == "price" && /[a-zA-Z]/.test(e.target.value)) {
      // Set value to 0, but don't do it if the user is just deleting
      if (e.target.value.trim() === "") {
        e.target.value = 0; // Allow empty input to be reset to 0 if nothing is typed
      }
      return; // Do not process further if input is invalid
    }
    _productEco[index][e.target.name] = e.target.value;
    setEcomChange(true);
    setState({ ...state, productEco: _productEco });
  };

  const onChangeSwitch = (name, value) => {
    const _productDetail = { ...productDetail };
    _productDetail[name] = value;
    setState({ ...state, productDetail: _productDetail });
  };

  const onDetailSave = () => {
    const _productDetail = { ...productDetail };
    if (productDetail.price == "") {
      productDetail.price = 0;
    }

    if (_productDetail.url_ar != "" && !isValidUrl(_productDetail.url_ar)) {
      toastError("Url AR is not valid, please check again");
      return;
    }

    let isValid = true;

    // for (const key in _productDetail) {
    //   if (_productDetail[key] == '' && key != 'is_preorder' && key != 'is_rental' && key != 'is_active' && (key != 'manual_book' || _productDetail['manual_book'] == '')) {
    //     isValid = false;
    //   }
    // }

    if (isValid) {
      const index = productDetails.findIndex(
        (e) => e.language_code == _productDetail.language_code
      );
      if (index > -1) {
        productDetails[index] = _productDetail;
      } else {
        productDetails.push(_productDetail);
      }

      setState({ ...state, productDetails });
      setIsDetailSaved(true);
      onSaveDraft();
      // toastSuccess("Save detail success");
    } else {
      toastError("Please complete the form");
    }
  };

  const onDetailReset = () => {
    const _productDetail = {
      ...productDetail,
      title: "",
      header_description: "",
      description: "",
      feature: "",
      including: "",
      tagline: "",
      price: "",
      id_color: "",
      id_tag: "",
      manual_book: null,
      is_preorder: 0,
      is_active: true,
      seo_title: "",
      seo_description: "",
      url_ar: "",
    };

    setState({ ...state, productDetail: _productDetail });
  };

  const onAddFileDescImage = (file) => {
    setState({ ...state, fileSelectedNew: {} });
    setHighlightChange(true);
    let file_nama = file.file_name || file.fileName || file.name;
    const fileName = file_nama.split(" ").join("");
    if (filesDescsNew[fileName]) {
      setState({ ...state, fileSelectedNew: filesDescsNew[fileName], filesDescsNew });
    } else {
      filesDescsNew[fileName] = {
        fileIndex: fileName,
        fileName,
        media_desc: "",
        media_types: [],
        content_types: [],
      };
      setState({
        ...state,
        filesDescsNew,
        fileSelectedNew: filesDescsNew[fileName],
      });
    }
    setTimeout(() => {
      $(modalId4).modal("show");
    }, 150);
  };

  const onCloseModal4 = () => {
    if (
      fileSelectedNew.media_types.length > 0 &&
      fileSelectedNew.media_types.toString().includes("highlight") &&
      !fileSelectedNew.media_types.toString().includes("usp")
    ) {
      if (fileSelectedNew.media_desc == "") {
        toastError("Please fill image description!");
        return;
      }

      setTimeout(() => {
        $(modalId4).modal("hide");
      }, 150);
    } else {
      toastError(
        "Please complete image type is highlight product or remove usp product description!"
      );
      return;
    }
  };

  const onCloseModal5 = (e, index) => {
    if (
      productUps[index].media_type.length > 0 &&
      productUps[index].media_desc != "" &&
      productUps[index].media_type.toString().includes("usp") &&
      !productUps[index].media_type.toString().includes("highlight")
    ) {
      setTimeout(() => {
        $(modalId5 + index).modal("hide");
      }, 150);
    } else {
      toastError(
        "Please complete image type is usp product or remove highlight description!"
      );
      // onAddFileDescModalUsp('usp_product','media_types')
      return;
    }
  };

  const onDescChange = (e) => {
    setHighlightChange(true);
    filesDescsNew[fileSelectedNew.fileName].media_desc = e.target.value;
    const _fileSelectedNew = { ...fileSelectedNew, media_desc: e.target.value };
    setState({ ...state, filesDescsNew, fileSelectedNew: _fileSelectedNew });
  };

  const onAddFileDescModal = (type, position, fileSelected) => {
    if (!fileSelectedNew) fileSelectedNew = fileSelected;
    console.log(fileSelectedNew);
    console.log(filesDescsNew[fileSelectedNew.fileName]);
    const index =
      position == "media_types"
        ? filesDescsNew[fileSelectedNew.fileName].media_types.indexOf(type)
        : filesDescsNew[fileSelectedNew.fileName].content_types.indexOf(type);

    if (index > -1) {
      position == "media_types"
        ? filesDescsNew[fileSelectedNew.fileName].media_types.splice(index, 1)
        : filesDescsNew[fileSelectedNew.fileName].content_types.splice(
          index,
          1
        );
    } else {
      position == "media_types"
        ? filesDescsNew[fileSelectedNew.fileName].media_types.push(type)
        : filesDescsNew[fileSelectedNew.fileName].content_types.push(type);
    }
    setState({ ...state, filesDescsNew });
  };

  const onDescChangeUsp = (e, index) => {
    const _productUps = [...productUps];
    _productUps[index].media_desc = e.target.value;
    setUspChange(true);
    setState({ ...state, productUps: _productUps });
  };

  const onAddFileDescModalUsp = (indexNew, type, position) => {
    // const _productUps = [...productUps];
    const _productUps = [...productUps];
    _productUps[indexNew].media_type =
      typeof _productUps[indexNew].media_type === "string"
        ? _productUps[indexNew].media_type.split(",")
        : _productUps[indexNew].media_type;
    _productUps[indexNew].content_type =
      typeof _productUps[indexNew].content_type === "string"
        ? _productUps[indexNew].content_type.split(",")
        : _productUps[indexNew].content_type;
    // const _filesDescsUps = [...filesDescsUps];

    const index =
      position == "media_types"
        ? _productUps[indexNew].media_type
          ? _productUps[indexNew].media_type.indexOf(type)
          : _productUps[indexNew].media_types.indexOf(type)
        : _productUps[indexNew].content_type.indexOf(type);

    if (index > -1) {
      if (position == "media_types") {
        _productUps[indexNew].media_type.splice(index, 1);
        _productUps[indexNew].media_types = [
          ..._productUps[indexNew].media_type,
        ];
        // _productUps[indexNew].media_types.splice(index, 1);
      } else {
        _productUps[indexNew].content_type.splice(index, 1);
        _productUps[indexNew].content_types = [
          ..._productUps[indexNew].content_type,
        ];
      }
    } else {
      if (position == "media_types") {
        _productUps[indexNew].media_type.push(type);
        _productUps[indexNew].media_types = _productUps[indexNew].media_type;
        //_productUps[indexNew].media_types.push(type);
      } else {
        _productUps[indexNew].content_type.push(type);
        _productUps[indexNew].content_types =
          _productUps[indexNew].content_type;
      }
    }
    const tempFilesDescs = {};
    if (_productUps && _productUps.length > 0) {
      _productUps.forEach((item) => {
        const file_name = item.file_name || item.fileName || item.name;
        tempFilesDescs[file_name] = item;
      });
    }

    setState({
      ...state,
      prod_productUps: _productUps,
      filesDescsUps: tempFilesDescs,
      filesDescsUpss: tempFilesDescs,
    });
  };

  const onFileChangeImage = (e) => {
    // if (!filesNew) filesNew = [];
    if (e.target.files[0].size > 10000000) {
      toastError("Size Image Too Large");
    } else {
      const _filesNew = [...filesNew, ...e.target.files];
      setHighlightChange(true);
      setState({ ...state, filesNew: _filesNew });
    }
  };

  const onRemoveFileImage = (file, i) => () => {
    const _deletedFileNew = [];
    const _filesDescsNew = filesDescsNew;
    const fileName = (file.name || file.fileName).split(" ").join("");
    _filesDescsNew[fileName] = {
      fileName,
      media_desc: "",
      media_types: [],
      content_types: [],
    };

    if (i == 0) {
      const _deletedFileNew = [deletedFileNew];
      const _fileSelectedNew = {};
    } else {
      const _deletedFileNew = [...deletedFileNew];
      const _fileSelectedNew = [...fileSelectedNew];
    }
    if (file.url) {
      const file_name = file.fileName || file.file_name || file.name;
      _deletedFileNew.push(file_name);
    }
    const arrFilesDescsNew = Object.keys(_filesDescsNew).map((key) => ({
      key,
      value: _filesDescsNew[key],
    }));
    filesNew.splice(i, 1);
    arrFilesDescsNew.splice(i, 1);
    // _filesDescsNew[fileName] = {};
    const _objFilesDescsNew = arrFilesDescsNew.reduce((acc, curr) => {
      acc[curr.key] = curr.value;
      return acc;
    }, {});
    setHighlightChange(true);
    setState({
      ...state,
      filesNew,
      filesDescsNew: arrFilesDescsNew,
      deletedFileNew: _deletedFileNew,
      fileSelectedNew: _objFilesDescsNew,
    });
    setHighlightChange(true);
  };

  const onHighlightSave = () => {
    const _productHighlights = [...productHighlights];

    const langIndex = _productHighlights.findIndex(
      (e) => e.language_code == productDetail.language_code
    );

    let isValid = "true";
    if (
      productHighlight.length > 0 &&
      filesNew.length > 0 &&
      (Object.keys(fileSelectedNew.media_types).length > 0 ||
        fileSelectedNew.media_types.toString().includes("highlight"))
    ) {
      for (let key in productHighlight) {
        if (
          productHighlight[key].title == "" ||
          productHighlight[key].description == "" ||
          filesNew[0].name == ""
        ) {
          isValid = false;
        }
      }
    } else {
      isValid = false;
    }
    if (isValid) {
      if (langIndex > -1) {
        _productHighlights[langIndex].data = productHighlight;
      } else {
        _productHighlights.push({
          language_code: productDetail.language_code,
          data: productHighlight,
        });
      }

      setState({ ...state, productHighlights: _productHighlights });
      toastSuccess("Save data to draft success");
    } else {
      toastError("Please complete the form and description file first!");
      return;
    }
  };

  const addRow = (index) => {
    const _productHighlights = [...productHighlights];

    const langIndex = productDetails.findIndex(
      (e) => e.language_code == productDetail.language_code
    );
    const len = _productHighlights.filter(
      (item) => item.language_code == productDetail.language_code
    ).length;

    if (len < 3 && langIndex > -1) {
      productDetails.map((high) => {
        _productHighlights.push({
          id: null,
          language_code: high.language_code,
          language_name: high.language_name,
          line_num: index,
          title: "",
          description: "",
        });
      });
      // _productHighlights.push({
      //   language_code: productDetail.language_code,
      //   language_name: productDetail.language_name,
      //   line_num: index,
      //   title: '',
      //   description: '',
      //   id: null,
      // });

      setState({ ...state, productHighlights: _productHighlights });
    } else {
      if (len == 3) {
        toastError("Error form tidak boleh lebih dari 3");
      } else {
        toastError("Error pilih bahasa dahulu");
      }
    }
  };

  const removeRow = (line_num) => {
    const _productHighlights = [...productHighlights];
    const _deletedHighlight = [...deletedHighlight];
    const _productDetails = [productDetails];
    const _productDetail = [productDetail];

    _productHighlights
      .filter((high) => high.line_num == line_num && high.id != null)
      .map((s) =>
        _deletedHighlight.push({
          id: s.id,
          language_code: s.language_code,
          language_name: s.language_name,
          line_num: s.line_num,
          title: s.title,
          description: s.description,
        })
      );

    const newProdHighlight = _productHighlights
      .filter((high) => high.line_num != line_num)
      .map((a) => a);

    if (line_num == 1) {
      newProdHighlight
        .filter((a) => a.line_num > 0)
        .map((item) =>
          newProdHighlight.push({
            id: item.id,
            language_code: item.language_code,
            language_name: item.language_name,
            line_num: line_num,
            title: item.title,
            description: item.description,
          })
        );
      const _newProdHighlight = newProdHighlight.filter(
        (a) => a.line_num <= line_num
      );
      setState({
        ...state,
        productHighlights: _newProdHighlight,
        deletedHighlight: _deletedHighlight,
      });
    } else if (line_num == 0) {
      const idNewProd = newProdHighlight.findIndex((a) => a.line_num == 1);
      if (idNewProd > 0) {
        newProdHighlight
          .filter((a) => a.line_num == 1)
          .map((item) =>
            newProdHighlight.push({
              id: item.id,
              language_code: item.language_code,
              language_name: item.language_name,
              line_num: line_num,
              title: item.title,
              description: item.description,
            })
          );
        const _newProdHighlight = newProdHighlight.filter(
          (a) => a.line_num != line_num + 1
        );
        _newProdHighlight
          .filter((a) => a.line_num > 1)
          .map((item) =>
            _newProdHighlight.push({
              id: item.id,
              language_code: item.language_code,
              language_name: item.language_name,
              line_num: line_num + 1,
              title: item.title,
              description: item.description,
            })
          );
        const _newProdHighlights = _newProdHighlight.filter(
          (a) => a.line_num <= line_num + 1
        );
        setState({
          ...state,
          productHighlights: _newProdHighlights,
          deletedHighlight: _deletedHighlight,
        });
      } else {
        newProdHighlight
          .filter((a) => a.line_num == 1)
          .map((item) =>
            newProdHighlight.push({
              id: item.id,
              language_code: item.language_code,
              language_name: item.language_name,
              line_num: line_num,
              title: item.title,
              description: item.description,
            })
          );
        const _newProdHighlight = newProdHighlight.filter(
          (a) => a.line_num == line_num
        );
        setState({
          ...state,
          productHighlights: _newProdHighlight,
          deletedHighlight: _deletedHighlight,
        });
      }
    } else {
      setState({
        ...state,
        productHighlights: newProdHighlight,
        deletedHighlight: _deletedHighlight,
      });
    }
    setHighlightChange(true);
  };

  const resetRow = (index) => {
    const _productHighlights = [...productHighlights];
    _productHighlights[index].title = "";
    _productHighlights[index].description = "";
    setState({ ...state, productHighlights: _productHighlights });
  };

  const onDetailChangeTextHighlight = (e, index) => {
    if (e.target.value.length == 200) {
      toastError("Max character 200");
      return;
    } else {
      const _productHighlights = [...productHighlights];
      _productHighlights[index][e.target.name] = e.target.value;
      setHighlightChange(true);
      setState({ ...state, productHighlights: _productHighlights });
    }
  };

  const onAddFileDescImageUps = (file, index) => {
    // const _productUps = [..._productUps];
    // setState({ ...state, fileSelectedUps: {} });
    // const fileNameUps = file.name.split(" ").join("");

    // if (filesDescsUps[index] && filesDescsUps[index].fileNameUps) {
    //   setState({ ...state, fileSelectedUps: filesDescsUps[index] });
    // } else {
    //   filesDescsUps[index] = {
    //     fileNameUps: fileNameUps,
    //     media_desc: '',
    //     language_code: productDetail.language_code,
    //     media_types: [],
    //     content_types: []
    //   }
    //   setState({ ...state, filesDescsUps, fileSelectedUps: filesDescsUps[index] });
    // }
    setTimeout(() => {
      $(modalId5 + index).modal("show");
    }, 150);
  };

  const onRemoveFileImageUps = (file, index) => () => {
    const _filesUps = [...filesUps];
    const _productUps = [...productUps]; //blomdapet
    const _deletedFileUps = [];
    const langIndex = productUps.findIndex(
      (e) => e.language_code == productDetail.language_code
    );
    if (file.url) {
      _deletedFileUps.push(file.fileNameUps);
    }

    if (index == 0) {
      const _deletedFileUps = [deletedFileUps];
      _filesUps[index] = {
        language_code: productDetail.language_code,
        data: [],
      };
      _productUps[index].filesUps = { name: "" };
    } else {
      const _deletedFileUps = [deletedFileUps];
      _filesUps[langIndex].data[index] = {};
      // _filesUps[langIndex].data.splice(index,1);
      _productUps[index].filesUps = { name: "" };
    }
    setUspChange(true);
    setState({
      ...state,
      filesUps: _filesUps,
      productUps: _productUps,
      deletedFileUps: _deletedFileUps,
    });
  };

  const onFileChangeImageUps = async (e, index) => {
    if (e.target.files[0]?.size > 10000000) {
      toastError("Size Image Too Large");
      return;
    } else if (!e.target.files[0]) {
      toastInfo("cancel choose image");
      return;
    } else {
      let tempFilesDescsUps = undefined;
      if (filesUps[index] && (filesUps[index]["file_name"] || filesUps[index]["fileName"])) {
        if (filesDescsUps) {
          if (Array.isArray(filesDescsUps)) {
            let target = filesUps[index]["file_name"] || filesUps[index]["fileName"];
            tempFilesDescsUps = [...filesDescsUps];
            const temp_desc = tempFilesDescsUps.filter(
              (item) =>
                item.fileName == filesUps[index]["file_name"] ||
                item.fileName == filesUps[index]["fileName"]
            );
            temp_desc["file_name"] = e.target.files[0].name;
            tempFilesDescsUps = tempFilesDescsUps.filter((item) => {
              return item.fileName != target;
            });
            tempFilesDescsUps.push(temp_desc);
          } else {
            tempFilesDescsUps = { ...filesDescsUps };
            let target = filesUps[index]["file_name"] || filesUps[index]["fileName"];
            tempFilesDescsUps[e.target.files[0].name] = tempFilesDescsUps[target];
            delete tempFilesDescsUps[target];
          }
        }
      }

      //const _filesDescsUps = [...filesDescsUps];
      const _filesUps = [...filesUps];
      let nameCheck = true;
      _filesUps.forEach((usp) => {
        if (usp.file_name == e.target.files[0].name) {
          toastError(
            "You cannot upload the same file as the previous one for USP!"
          );
          nameCheck = false;
        }
      });

      if (nameCheck == false) return;
      const _productUps = [...productUps];

      _filesUps[index] = e.target.files[0];
      // const langIndex = productUps.findIndex(e => e.language_code == productDetail.language_code);
      const idxTag = _productUps[0].tags.findIndex(
        (e) => e.language_code == productDetail.language_code
      );

      // if (_productUps?.file_path) {
      //   _deletedFileUps.push(_productUps[index]);
      // }

      if (productUps[index].file_name != null || productUps[index].name != null) {
        deletedUps.push({
          file_name: productUps[index].file_name || productUps[index].name,
          item_code: productUps[index].media_code,
        });
      }

      // const _deletedFileUps = [deletedFileUps]
      await previewFile(e.target.files[0], (files, value) => {
        _productUps[index] = {
          id: null,
          media_code: "",
          media_type: _productUps[index].media_type ?? [],
          media_desc: _productUps[index].media_desc,
          content_type: _productUps[index].content_type ?? [],
          name: files.name,
          file_change: true,
          size: files.size,
          file_path: value,
          tags: _productUps[index].tags
            ? _productUps[index].tags
            : [
              {
                line_num: index,
                title: "",
                description: "",
                language_code: productDetail.language_code,
              },
            ],
        };
        setUspChange(true);
        if (tempFilesDescsUps) {
          setState({
            ...state,
            productUps: _productUps,
            filesUps: _filesUps,
            filesDescsUps: tempFilesDescsUps,
            filesDescsUpss: tempFilesDescsUps,
          });
        } else {
          setState({ ...state, productUps: _productUps, filesUps: _filesUps });
        }
      });
    }
  };

  const onUpsSave = () => {
    const _productUpss = [...productUpss];
    const _filesDescsUpss = [...filesDescsUpss];

    const langIndex = _productUpss.findIndex(
      (e) => e.language_code == productDetail.language_code
    );

    let isValid = "true";
    if (
      productUps.length > 0 &&
      filesUps.length > 0 &&
      fileSelectedUps.media_types.length > 0 &&
      fileSelectedUps.media_types.toString().includes("usp")
    ) {
      for (let key in productUps) {
        if (
          productUps[key].title == "" ||
          productUps[key].description == "" ||
          filesUps[0].name == ""
        ) {
          isValid = false;
        }
      }
    } else {
      isValid = false;
    }

    if (isValid) {
      if (langIndex > -1) {
        _productUpss[langIndex].data = productUps;
        _filesDescsUpss[langIndex].data = filesDescsUps;
      } else {
        _productUpss.push({
          language_code: productDetail.language_code,
          data: productUps,
        });
        _filesDescsUpss.push({
          language_code: productDetail.language_code,
          data: filesDescsUps,
        });
      }
      setState({
        ...state,
        productUpss: _productUpss,
        filesDescsUpss: _filesDescsUpss,
      });
      toastSuccess("Save data to draft success");
    } else {
      toastError("Please complete the form and description file first!");
      return;
    }
  };

  const addRowUps = (index) => {
    const _productUps = [...productUps];
    const _filesUps = [...filesUps];
    // const langIndex = productUpss.findIndex(e => e.language_code == productDetail.language_code);

    // const idxTag = productDetails.findIndex(e => e.language_code == productDetail.language_code);

    if (_productUps.length < 3 && productDetail.language_code != "") {
      _productUps.push({
        id: null,
        name: "",
        media_code: "",
        media_type: [],
        media_desc: "",
        content_type: [],
        file_path: "",
        tags: [],
      });

      productDetails?.map((prod, indexDetail) =>
        _productUps[index].tags.push({
          line_num: index,
          title: "",
          description: "",
          language_code: prod.language_code,
        })
      );

      setState({ ...state, productUps: _productUps, filesUps: _filesUps });
    } else {
      if (_productUps.length == 3) {
        toastError("Error form tidak boleh lebih dari 3");
      } else {
        toastError("Error pilih bahasa dahulu");
      }
    }
  };

  const removeRowUsp = (index) => {
    const _productUps = [...productUps];
    const _filesUps = [...filesUps];
    const _filesDescsUps = filesDescsUps;
    if (_filesUps[index]?.file_name != null || _filesUps[index]?.name != null) {
      deletedUps.push({
        file_name: _filesUps[index].file_name,
        item_code: _filesUps[index].media_code,
      });
    }

    let keys = Object.keys(_filesDescsUps);
    delete _filesDescsUps[keys[index]];

    _productUps.splice(index, 1);
    _filesUps.splice(index, 1);

    setUspChange(true);
    setState({
      ...state,
      productUps: _productUps,
      filesUps: _filesUps,
      deletedUps: deletedUps,
      filesDescsUps: _filesDescsUps,
    });
  };

  const resetRowUsp = (index) => {
    const _productUps = [...productUps];
    // const _productUps = [...productUps];
    // const idxTag = productDetails.tags.findIndex(e => e.language_code == productDetail.language_code);
    _productUps[index].tags.map((tag, idxTag) => {
      if (
        _productUps[index].tags[idxTag].language_code ==
        productDetail.language_code
      ) {
        _productUps[index].tags[idxTag].title = "";
        _productUps[index].tags[idxTag].description = "";
      }
    });

    setState({ ...state, productUps: _productUps });
  };

  const onDetailChangeTextUps = (e, index, prodIndex) => {
    if (e.target.value.length == 200) {
      toastError("Max character 200");
      return;
    } else {
      const _productUps = [...productUps];

      _productUps[index].tags[prodIndex][e.target.name] = e.target.value;
      setUspChange(true);
      setState({ ...state, productUps: _productUps });
    }
  };

  const addRowEcom = (index) => {
    const _productEcom = [...productEcom];

    if (_productEcom.length < 10) {
      _productEcom.push({
        id: null,
        id_store: null,
        url: "",
        price: null,
        line_num: index,
      });
      setState({ ...state, productEcom: _productEcom });
    } else {
      if (_productEcom.length == 10) {
        toastError("Error form tidak boleh lebih dari 10");
      } else {
        toastError("Error pilih bahasa dahulu");
      }
    }
  };

  const removeRowEcom = (index, id) => {
    const _productEcom = [...productEcom];
    const _deletedEcom = [...deletedEcom];

    if (id != null) {
      setEcomChange(true);
      _productEcom
        .filter((com) => com.id == id)
        .map((s) =>
          _deletedEcom.push({
            id: s.id,
            id_store: s.id_store,
            item_code: s.item_code,
            country_code: s.country_code,
          })
        );
    }

    _productEcom.splice(index, 1);

    setState({
      ...state,
      productEcom: _productEcom,
      deletedEcom: _deletedEcom,
    });
  };

  let {
    languages,
    productDetails,
    productDetail,
    productHighlights,
    productHighlight,
    selectedLang,
    deletedDetail,
    deletedHighlight,
    deletedUps,
    deletedUpsTag,
    deletedEcom,
    manualBooks,
    manualBooksDelete,
    activeTab,
    show,
    filesDescsNew,
    filesNew,
    filesUps,
    filesDescsUps,
    filesDescsUpss,
    fileSelectedUps,
    deletedFileUps,
    numRowsUps,
    fileSelectedNew,
    deletedFileNew,
    productUps,
    productUpss,
    media_types,
    content_types,
    productEcom,
  } = state;
  useEffect(() => {
    if (countryChange != "" && productDetail.language_code != "") {
      const reqProductCode = getProductColor(
        countryChange,
        productDetail.language_code
      ).then((res) => res.data);
      const reqProductTag = getProductTag(
        countryChange,
        productDetail.language_code
      ).then((res) => res.data);
      const reqStoreOnline = getStoreOnlineAll({
        orders: "store_name:asc",
        perpage: 100,
      }).then((res) => res.data);

      Promise.all([reqProductCode, reqProductTag, reqStoreOnline]).then(
        (results) => {
          const [_colors, _tags, _store] = results;

          setDetailState({
            ...detailState,
            productColors: _colors,
            productTags: _tags,
          });

          setEcomState({
            ...ecomState,
            storeLoc: _store.data,
          });
        }
      );
    } else {
      setDetailState({ ...detailState, productColors: [], productTags: [] });
    }
  }, [countryChange, productDetail]);

  const { productColors, productTags } = detailState;
  const { storeLoc } = ecomState;
  const propsProductDetailInformation = {
    productDetail,
    onDetailChangeText,
    productColors,
    productTags,
    onFileChange,
    onRemoveFile,
    onChangeSwitch,
    onDetailReset,
    onDetailSave,
    approval_status,
    next_step_nik_detail,
  };
  const propsProductHighlight = {
    filesNew,
    deletedHighlight,
    filesDescsNew,
    productDetail,
    productHighlights,
    productHighlight,
    deletedFileNew,
    selectedLang,
    setState,
    wrapStyle2,
    onAddFileDescImage,
    onDetailChangeTextHighlight,
    onFileChangeImage,
    onRemoveFileImage,
    removeRow,
    resetRow,
    addRow,
    onHighlightSave,
    approval_status,
    next_step_nik_detail,
  };
  const propsProducUspHighlight = {
    filesUps,
    deletedUps,
    filesDescsUps,
    filesDescsUpss,
    productUps,
    productUpss,
    numRowsUps,
    productDetail,
    productDetails,
    onDetailChangeTextUps,
    removeRowUsp,
    resetRowUsp,
    addRowUps,
    onUpsSave,
    onFileChangeImageUps,
    onRemoveFileImageUps,
    setState,
    wrapStyle,
    onAddFileDescImageUps,
    modalId5,
    onCloseModal5,
    filesDescsUps,
    fileSelectedUps,
    media_types,
    content_types,
    onAddFileDescModalUsp,
    onDescChangeUsp,
    approval_status,
    next_step_nik_detail,
    is_draft_saved,
  };
  const propsProductEcommerce = {
    productEcom,
    storeLoc,
    onEcoChangeText,
    addRowEcom,
    removeRowEcom,
    productDetail,
    deletedEcom,
    approval_status,
    next_step_nik_detail,
  };

  const propsModalImageHighlight = {
    modalId4,
    onCloseModal4,
    filesDescsNew,
    fileSelectedNew,
    media_types,
    content_types,
    onAddFileDescModal,
    onDescChange,
    approval_status,
  };
  //const propsModalImageUsp = { modalId5, onCloseModal5, filesDescsUps, fileSelectedUps, media_types, content_types, onAddFileDescModalUsp, onDescChangeUsp };
  //console.log('productDetail', productDetail)
  //console.log('productEcom', productEcom)
  return (
    <div className="row">
      <div className="col-md-12">
        <div className="col-md-3">
          <div className="form-group">
            <label>Language</label>
            <div className="d-flex justify-content-between">
              <select
                id="language"
                className="form-control mr-2"
                onChange={onSelectLang}
                disabled={
                  approval_status == "ONPROGRESS" ||
                  (approval_status == "ONREVISED" &&
                    next_step_nik_detail != userInfo.nik)
                }
              >
                <option value={""}>Select Language</option>
                {languages.map((item, i) => {
                  if (
                    productDetails.findIndex(
                      (pd) => pd.language_code == item.language_code
                    ) < 0
                  ) {
                    return (
                      <option key={"lang-" + i} value={item.language_code}>
                        {item.language_name}
                      </option>
                    );
                  }
                })}
              </select>
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={onAddLang}
                disabled={
                  approval_status == "ONPROGRESS" ||
                  (approval_status == "ONREVISED" &&
                    next_step_nik_detail != userInfo.nik)
                }
              >
                Add
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-12">
          <div className="form-group mt-2">
            <div className="d-flex flex-wrap">
              {productDetails.length > 0 ? (
                productDetails.map((item, i) => (
                  <div
                    key={`item-${i}`}
                    className={`btn btn${item.language_code == productDetail.language_code
                      ? "-"
                      : "-outline-"
                      }warning btn-sm d-flex mr-2 mb-2`}
                  >
                    <a
                      onClick={() => onLanguageClick(item)}
                      type="button"
                      style={{ minWidth: 100 }}
                    >
                      <CountryFlag code={item.language_code} />
                      {item.language_name}
                    </a>
                    {(approval_status != "ONPROGRESS" ||
                      (approval_status == "ONREVISED" &&
                        next_step_nik_detail != userInfo.nik)) && (
                        <span
                          onClick={() => onRemoveLang(item.language_code)}
                          className="text-danger"
                          style={{ cursor: "pointer" }}
                        >
                          <i className="fa fa-times ml-2"></i>
                        </span>
                      )}
                  </div>
                ))
              ) : (
                <div></div>
              )}
            </div>
          </div>
        </div>
        <div className="accordian">
          <div className="accordian-header" onClick={handleOpen}>
            {/* <div className="tanda">{show ? '-' : '+'}</div> */}
            <div className="mb-2 mt-2">Additional Information</div>
          </div>
          {/* {show && ( */}
          <div>
            <div className="tab">
              <p
                className={
                  activeTab === "tab1" ? "tablinks active" : "tablinks"
                }
                onClick={() => handleTabClick("tab1")}
              >
                {" "}
                Product Detail{" "}
              </p>
              <p
                className={
                  activeTab === "tab2" ? "tablinks active" : "tablinks"
                }
                onClick={() => handleTabClick("tab2")}
              >
                Product Highlight
              </p>
              <p
                className={
                  activeTab === "tab3" ? "tablinks active" : "tablinks"
                }
                onClick={() => handleTabClick("tab3")}
              >
                USP Product Highlight
              </p>
              <p
                className={
                  activeTab === "tab4" ? "tablinks active" : "tablinks"
                }
                onClick={() => handleTabClick("tab4")}
              >
                Product Ecommerce
              </p>
            </div>

            <div className="tabcontent">
              {activeTab === "tab1" && (
                <div>
                  <ProductDetailInformation
                    {...propsProductDetailInformation}
                  />
                </div>
              )}
              {activeTab === "tab2" && (
                <div className="row">
                  <div className="col-md-12">
                    <ProductHighlight {...propsProductHighlight} />
                  </div>
                </div>
              )}
              {activeTab === "tab3" && (
                <div className="row">
                  <div className="col-md-12">
                    <ProductUspHighlight {...propsProducUspHighlight} />
                  </div>
                </div>
              )}
              {activeTab === "tab4" && (
                <div className="row">
                  <div className="col-md-12">
                    <ProductEcommerce {...propsProductEcommerce} />
                  </div>
                </div>
              )}
            </div>
          </div>
          {/* )} */}
        </div>
      </div>
      <ModalImageHighlight {...propsModalImageHighlight} />
      {/* <ModalImageUsp {...propsModalImageUsp} /> */}
    </div>
  );
};

export default ProductDetailPage;
